// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumbs_container__Nkt16","MuiBreadcrumbs-separator":"BreadCrumbs_MuiBreadcrumbs-separator__YOasy","isActive":"BreadCrumbs_isActive__1c9Cs"};